import { adminCall, adminGet } from './adminCall';

export async function adminGetSupportHours() {
  const result = await adminGet('/api/admin/platform/support-hours');
  return result.hours || {};
}

export async function adminSetSupportHours(hours) {
  const result = await adminCall('/api/admin/platform/support-hours', { hours });
  return result.hours || hours;
}
